import { getLanguageFromFullLocale } from "../../lib/config";

export const inventoryQueryKeys = {
  all: ["inventory"] as const,
  lists: () => [...inventoryQueryKeys.all, "entries"] as const,
  list: (propertyTicker: string, locale: string) =>
    [...inventoryQueryKeys.lists(), propertyTicker, getLanguageFromFullLocale(locale)] as const,
  states: () => [...inventoryQueryKeys.all, "state"] as const,
  state: (propertyTicker: string) => [...inventoryQueryKeys.states(), propertyTicker] as const,
  tables: () => [...inventoryQueryKeys.all, "table"] as const,
  table: (propertyTicker: string) => [...inventoryQueryKeys.tables(), propertyTicker] as const,
};
